import React from 'react'
import { MAIN_SEARCH_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import Button from './button'

const SearchAIButton = ({ style, className, iconStyle, puresvg, onClick }) => {
    return (
        <Button
            tabIndex={MAIN_SEARCH_BUTTON_INDEX}
            id="search_desktop"
            alt="search"
            icon="search"
            style={style}
            svgStyle={iconStyle}
            puresvg={puresvg}
            onClick={onClick}
            className={className}
        />
    )
}

export default SearchAIButton
